export default "__VITE_ASSET__B564Stuh__";